import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function Pricing() {
  return (
    <section class="bg-white pb-8 relative overflow-hidden">
      <div class="container w-full max-w-6xl sm:mx-auto px-2 pt-8 pb-12 text-gray-800">
        <div className="justifiy-center flex flex-wrap w-full z-20 mt-20">
          <h3 class="text-3xl text-white mx-auto z-20 w-full text-center font-bold leading-none mb-2">
            Our Subscriptions
          </h3>
          <div className="w-28 h-1  z-10 bg-white mx-auto "></div>
        </div>
        <div class="w-full mb-4">
          <div class="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t"></div>
        </div>

        <div class="flex flex-col sm:flex-row justify-center pt-12 mb-12 sm:my-4">
          <div class="flex flex-col lg:w-1/3 mx-6 sm:mx-auto lg:mx-0 rounded-none lg:rounded-l-lg bg-white mt-4 z-10">
            <div class="flex-1 bg-white text-gray-600 rounded-t rounded-b-none overflow-hidden shadow">
              <div class="p-8 text-xl font-bold text-center border-b-4">
                BASIC STUDENT MEMBERSHIP
              </div>
              <ul class="w-full text-center text-sm">
                {[
                  "IEEE Spectrum",
                  "IEEE e-mail alias",
                  "IEEE Xplore Digital Library",
                  "Google Apps (30GB Storage)",
                  "The Institute Newsletter",
                  "IEEE Job Site",
                  "Scholarships",
                  "Monthly Status Reports",
                ].map((el, i) => {
                  return (
                    <li class="border-b text-center flex py-2">
                      <div className="text-gray-600 mx-auto flex  font-normal">
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="text-green-600 text-2xl my-auto pr-2"
                        />
                        <span className="my-auto text-gray-800 font-medium text-lg">
                          {el}
                        </span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow p-6">
              <div class="w-full pt-2 text-5xl font-normal text-gray-800 text-center">
                &#36;27
                <span class="text-sm text-gray-600 font-normal">
                  / per year
                </span>
              </div>
              <div class="flex items-center justify-center">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.ieee.org/membership/join/index.html"
                >
                  <button className="mx-auto lg:mx-0 gradient bg-blue-600 mt-4 hover:bg-blue-800 text-white font-bold rounded-full py-4 px-8 shadow-lg">
                    Purchase
                  </button>
                </a>
              </div>
            </div>
          </div>

          <div class="flex flex-col lg:w-1/3  mx-6 sm:mx-auto lg:mx-0 rounded-lg bg-white mt-4 sm:-mt-6 shadow-lg z-20">
            <div class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
              <div class="w-full p-8 text-xl font-bold text-center">
                STANDARD SOCIETY MEMBERSHIPS
              </div>
              <div class="h-1 w-full gradient my-0 py-0 rounded-t"></div>
              <ul class="w-full text-center text-base font-bold">
                <li class="border-b text-center py-4">
                  <span className="text-gray-600 font-normal">
                    POWER ENERGY SOCIETY
                  </span>
                  <h1 className="text-5xl font-normal ">
                    {" "}
                    &#36;17.5
                    <span class="text-sm text-gray-600 font-normal">
                      / per year
                    </span>
                  </h1>
                </li>
                <li class="border-b text-center py-4">
                  <span className="text-gray-600 font-normal">
                    COMPUTER SOCIETY
                  </span>
                  <h1 className="text-5xl font-normal ">
                    {" "}
                    &#36;8
                    <span class="text-sm text-gray-600 font-normal">
                      / per year
                    </span>
                  </h1>
                </li>

                <li class="border-b text-center py-4">
                  <span className="text-gray-600 font-normal">
                    ROBOTICS AND AUTOMATION SOCIETY
                  </span>
                  <h1 className="text-5xl font-normal ">
                    {" "}
                    &#36;5
                    <span class="text-sm text-gray-600 font-normal">
                      / per year
                    </span>
                  </h1>
                </li>
              </ul>
            </div>
            <div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow p-6">
              <div class="flex items-center justify-center">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.ieee.org/membership-catalog/societies.html"
                >
                  <button className="mx-auto lg:mx-0 gradient bg-blue-600 mt-4 hover:bg-blue-800 text-white font-bold rounded-full py-4 px-8 shadow-lg">
                    Purchase
                  </button>
                </a>
              </div>
            </div>
          </div>

          <div class="flex flex-col lg:w-1/3  mx-6 sm:mx-auto lg:mx-0 rounded-none lg:rounded-l-lg bg-white mt-4 z-10">
            <div class="flex-1 bg-white text-gray-600 rounded-t rounded-b-none overflow-hidden shadow">
              <div class="p-8 text-xl font-bold text-center border-b-4">
                WOMEN IN ENGINEERING (WIE)
              </div>
              <ul class="w-full text-center text-sm">
                {[
                  "IEEE WIE Magazine",
                  "Volunteer opportunities",
                  "IEEE WIE Newsletter",
                  "IEEE Member Directory",
                  "Tuition benefit opportunities",
                  "IEEE WIE awards",
                  "Scholarships",
                  "Travel grants",
                ].map((el, i) => {
                  return (
                    <li class="border-b text-center flex py-2">
                      <div className="text-gray-600 mx-auto flex  font-normal">
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="text-green-600 text-2xl my-auto pr-2"
                        />
                        <span className="my-auto text-gray-800 font-medium text-lg">
                          {el}
                        </span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow p-6">
              <div class="w-full pt-2 text-5xl font-normal text-gray-800 text-center">
                &#36;0
                <span class="text-sm text-gray-600 font-normal">
                  / per year
                </span>
              </div>
              <div class="flex items-center  justify-center">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://wie.ieee.org/membership/"
                >
                  <button className="mx-auto lg:mx-0 gradient bg-blue-600 mt-4 hover:bg-blue-800 text-white font-bold rounded-full py-4 px-8 shadow-lg">
                    Purchase
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="flex pricing-bg transform sm:rotate-6 bg-blue-600 rounded mt-16 -ml-4 sm:-ml-16 2xl:rotate-0 2xl:-ml-20 absolute top-0 left-0 -z-40 "></div>
      </div>
    </section>
  );
}
